module.exports = __webpack_public_path__ + "static/media/9DESA17.e08e795f.jpg";